"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validProperties = void 0;
// Naming conventions for token suffixes in the wiki
exports.validProperties = [
    'background_color',
    'border_color',
    'border_width',
    'character',
    'corner_radius',
    'custom_enabled',
    'duration',
    'easing',
    'elevation',
    'family_name',
    'family_stack',
    'fill',
    'fill_color',
    'font',
    'font_leading',
    'font_line_height',
    'font_size',
    'font_weight',
    'gradient',
    'offset_bottom',
    'offset_leading',
    'offset_left',
    'offset_right',
    'offset_top',
    'offset_trailing',
    'opacity',
    'shadow',
    'sizing_height',
    'sizing_width',
    'sizing',
    'spacing_between',
    'spacing_inner_bottom',
    'spacing_inner_horiz',
    'spacing_inner_leading',
    'spacing_inner_left',
    'spacing_inner_right',
    'spacing_inner_top',
    'spacing_inner_trailing',
    'spacing_inner_vert',
    'spacing_inner',
    'spacing_outer_bottom',
    'spacing_outer_horiz',
    'spacing_outer_leading',
    'spacing_outer_left',
    'spacing_outer_right',
    'spacing_outer_top',
    'spacing_outer_trailing',
    'spacing_outer_vert',
    'spacing_outer',
    'text_color',
    'text_decoration',
    'text_shadow',
    'unicode_range',
    'url',
    'woff',
    'woff2',
];
//# sourceMappingURL=valid-properties.js.map